//
//
//
//
//
//
//
//
//
//

import manualButton from '../manual-button';
export default {
  name: "source-pagination",
  components: {
    manualButton,
  },
  data() {
    return {
      show: true,
      statusList:[
        {name:'全部', code:'', selected: true},
        {name:'未开始',code:'notStarted'},
        {name:'进行中', code:'going'},
        {name:'已结束', code:'finish'},
        {name:'暂停', code:'pause'}
      ],
      sourceChildTypeList: [
        {name: '全部', code: '', selected: true},
        {name: '物品类', code: 'code1'},
        {name: '项目类', code: 'code2'},
        {name: '服务类', code: 'code3'},
      ],
      sourceWayList: [
        {name: '全部', code: '', selected: true},
        {name: '公开参与', code: 'PUBLIC'},
        {name: '邀请参与', code: 'INVITATION'},
      ],
      checkedDtoList:[]
    }
  },
  methods: {
    closeReset(){},
    reload(){
      this.checkedDtoList=[];
      this.show=false;
      this.$nextTick(()=>{
        this.show=true;
      })
    },
    checkerChange(value,name,chinese,option="IN"){
      this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
      this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/manual-search/source-pagination.vue